import { render, staticRenderFns } from "./SvTalk.vue?vue&type=template&id=31de0732"
import script from "./SvTalk.vue?vue&type=script&lang=js"
export * from "./SvTalk.vue?vue&type=script&lang=js"
import style0 from "./SvTalk.vue?vue&type=style&index=0&id=31de0732&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports